export interface AddressData {
  firstname: string;
  lastname: string;
  code: string;
  street: string;
  zip: string;
  city: string;
  country: string;
  info: string;
  birthDate: string;
}

export class AddressData implements AddressData {
  firstname = '';
  lastname = '';
  code = '';
  street = '';
  zip = '';
  city = '';
  country = '';
  info = '';
  birthDate = '';
}
